import { render, staticRenderFns } from "./Gen.vue?vue&type=template&id=0fc4f214&scoped=true&"
import script from "./Gen.vue?vue&type=script&lang=js&"
export * from "./Gen.vue?vue&type=script&lang=js&"
import style0 from "./Gen.vue?vue&type=style&index=0&id=0fc4f214&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc4f214",
  null
  
)

export default component.exports